(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["vonare-delivery"] && !Shopify.designMode) return;
  try {
    (() => {
    const easter = (year) => {
      const a = year % 19;
      const b = Math.floor(year / 100);
      const c = year % 100;
      const d = (19 * a + b - Math.floor(b / 4) - Math.floor((b - Math.floor((b + 8) / 25) + 1) / 3) + 15) % 30;
      const e = (32 + 2 * (b % 4) + 2 * Math.floor(c / 4) - d - (c % 4)) % 7;
      const f = Math.floor((a + 11 * d + 22 * e) / 451);
      const month = Math.floor((d + e - 7 * f + 114) / 31);
      const day = ((d + e - 7 * f + 114) % 31) + 1;
      return new Date(year, month - 1, day);
    };

    const FIXED = ['1-1', '1-6', '5-1', '5-3', '8-15', '11-1', '11-11', '12-24', '12-25', '12-26'];

    const isDayOff = (date) => {
      if (date.getDay() === 0 || date.getDay() === 6) return true;
      if (FIXED.includes(`${date.getMonth() + 1}-${date.getDate()}`)) return true;
      const e = easter(date.getFullYear());
      return [1, 60].some((offset) => {
        const holiday = new Date(e.getFullYear(), e.getMonth(), e.getDate() + offset);
        return holiday.getMonth() === date.getMonth() && holiday.getDate() === date.getDate();
      });
    };

    const addWorkingDays = (start, count) => {
      const date = new Date(start);
      let left = count;
      while (left > 0) {
        date.setDate(date.getDate() + 1);
        if (!isDayOff(date)) left -= 1;
      }
      return date;
    };

    const DAYS = ['niedz.', 'pon.', 'wt.', 'śr.', 'czw.', 'pt.', 'sob.'];
    const MONTHS = ['sty', 'lut', 'mar', 'kwi', 'maj', 'cze', 'lip', 'sie', 'wrz', 'paź', 'lis', 'gru'];
    const label = (date) => `${DAYS[date.getDay()]} ${date.getDate()} ${MONTHS[date.getMonth()]}`;

    // Shown only on working days before the dispatch hour; it never restarts the same day.
    const tickCutoff = (el) => {
      const now = new Date();
      const end = new Date(now);
      end.setHours(Number(el.dataset.cutoff), 0, 0, 0);
      const ms = end - now;
      if (isDayOff(now) || ms <= 0) {
        el.hidden = true;
        return;
      }
      const s = Math.floor(ms / 1000);
      const pad = (n) => String(n).padStart(2, '0');
      el.querySelector('[data-left]').textContent = `${pad(Math.floor(s / 3600))}:${pad(Math.floor((s % 3600) / 60))}:${pad(s % 60)}`;
      el.hidden = false;
    };

    const run = () => {
      const now = new Date();
      document.querySelectorAll('.vonare-delivery__dates').forEach((el) => {
        const from = addWorkingDays(now, Number(el.dataset.daysMin));
        const to = addWorkingDays(now, Number(el.dataset.daysMax));
        el.textContent = `${label(from)} – ${label(to)}`;
      });
      document.querySelectorAll('.vonare-delivery__cutoff').forEach((el) => {
        tickCutoff(el);
        setInterval(() => tickCutoff(el), 1000);
      });
    };

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
    else run();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["vonare-personalization"] && !Shopify.designMode) return;
  try {
    (() => {
    const MAX_BYTES = 20 * 1024 * 1024;

    const clearField = (field) => {
      const thumb = field.querySelector('.vonare-perso__thumb');
      field.querySelector('.vonare-perso__file-input').value = '';
      field.querySelector('.vonare-perso__file-name').textContent = 'Nie wybrano pliku';
      field.querySelector('.vonare-perso__remove').hidden = true;
      if (thumb.src) URL.revokeObjectURL(thumb.src);
      thumb.removeAttribute('src');
      thumb.hidden = true;
    };

    document.addEventListener('change', (event) => {
      const input = event.target;
      if (!(input instanceof HTMLInputElement) || !input.matches('.vonare-perso__file-input')) return;
      const field = input.closest('.vonare-perso__file-field');
      const error = field.querySelector('.vonare-perso__error');
      const file = input.files[0];
      error.hidden = true;
      if (!file || file.size > MAX_BYTES) {
        clearField(field);
        if (file) {
          error.textContent = 'Plik jest za duży. Maksymalny rozmiar to 20 MB.';
          error.hidden = false;
        }
        return;
      }
      field.querySelector('.vonare-perso__file-name').textContent = file.name;
      field.querySelector('.vonare-perso__remove').hidden = false;
      const thumb = field.querySelector('.vonare-perso__thumb');
      if (file.type.startsWith('image/')) {
        if (thumb.src) URL.revokeObjectURL(thumb.src);
        thumb.src = URL.createObjectURL(file);
        thumb.hidden = false;
      } else {
        thumb.hidden = true;
      }
    });

    document.addEventListener('click', (event) => {
      const target = event.target;
      if (!(target instanceof Element)) return;
      const remove = target.closest('.vonare-perso__remove');
      if (remove) {
        clearField(remove.closest('.vonare-perso__file-field'));
        return;
      }
      const more = target.closest('.vonare-perso__more');
      if (more) {
        const group = more.parentElement;
        const next = group.querySelector('.vonare-perso__file-field[hidden]');
        if (next) next.hidden = false;
        if (!group.querySelector('.vonare-perso__file-field[hidden]')) more.hidden = true;
      }
    });

    // Empty fields stay out of the cart line: the theme builds its FormData right after this
    // capture listener, and disabled controls are skipped. Window capture runs before the theme's own.
    // The form has an input named "id", so form.id would return that input, not the form's id.
    window.addEventListener(
      'submit',
      (event) => {
        const form = event.target;
        if (!(form instanceof HTMLFormElement)) return;
        const formId = form.getAttribute('id');
        if (!formId) return;
        const empty = [...document.querySelectorAll(`[form="${formId}"][data-vonare-perso]`)].filter(
          (field) => !field.value.trim()
        );
        empty.forEach((field) => {
          field.disabled = true;
        });
        setTimeout(() => {
          empty.forEach((field) => {
            field.disabled = false;
          });
        }, 0);
      },
      true
    );
  })();
  } catch(e) { console.error(e); }
})();

})();
